<template>
	<div class="container-fluid tab-pane active" id="charts">
        <div class="row">
            <div class="col-12 mb-3">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">Ligações de entrada por hora</div>
                        <GChart type="ColumnChart" :data="entradas" :options="chart_options" />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-md-12 mb-3">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">Ligações de saída por hora</div>
                        <GChart type="ColumnChart" :data="saidas" :options="chart_options" />
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-md-12 mb-3">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">{{view_nome.denuncia_detalhe}}s por hora</div>
                       <GChart type="ColumnChart" :data="denuncias" :options="chart_options" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { GChart } from 'vue-google-charts'
    import api        from '@/mixins/api.js'
    import { EventBus } from '@/event-bus.js';


    export default {
        name: "Graficos",
        components: { GChart },
        mixins: [ api ],

        data () {
            return {
                entradas:  [ ['Hora', 'Ligações'], [0, 0] ],
                saidas:    [ ['Hora', 'Ligações'], ["00 H", 0] ],
                denuncias: [ ['Hora', 'Ligações'], ["00 H", 0] ],

                timestamps: true,
                looping: null,
                teste: true,
                selectedUnit: 0,

                chart_options: {
                    'colors':['#186E67'],
                    'animation':{ duration:1000, easing:'linear', startup:true },
                    'chartArea':{ left:30,top:'5%',width:'100%',height:'80%' }
                }
            }
        },

        created() {
            this.get_data();
            this.$emit('update:form_date', true);
            EventBus.$on('unit-changed', this.onUnitChanged);
        },

        watch: {
		'$store.state.user.unidade_id': function (newVal) {
                if (newVal && this.$store.state.user.type !== 3) {
                    this.selectedUnit = newVal;
                    this.clear_data();
                    this.get_data();
                }
		    }
	    },


		computed: {
			view_nome(){ 
                return this.$store.state.config_view_menu;
            }
		},

        beforeDestroy() {
            EventBus.$off('unit-changed', this.onUnitChanged);
        },

        methods: {
            
            onUnitChanged(unitId) {
                this.selectedUnit = unitId;
                this.clear_data();
                this.get_data();
            },

            start_timestamps() {
                this.timestamps = true;
                this.clear_data();
                this.get_data("now");
            },

            refresh(aux) {
                if(aux){
                    clearTimeout(this.looping);
                    this.looping = setTimeout( () => this.get_data("now"), 7000);
                }
            },

            get_to_date(date) {
                this.teste = false;
                this.timestamps = false;
                this.clear_data();
                this.get_data(date);
            },

            clear_data() {
                this.entradas  = [ ['Hora', 'Ligações'], [0, 0] ];
                this.saidas    = [ ['Hora', 'Ligações'], ["00 H", 0] ];
                this.denuncias = [ ['Hora', 'Ligações'], ["00 H", 0] ];
            },

            async get_data(date = "now") {

                if (this.$store.state.user.type != 3)
                {
                    this.selectedUnit = this.$store.state.user.unidade_id;
                }
                
                if(this.selectedUnit != undefined)
                {
                    const response = await this.GET("Dashboard", `Graficos?date=${date}&unidade_id=${this.selectedUnit}`);

                if ( response.status == "success" ) {
                    if (response.result.entradas.length != 0){ 
                        this.entradas = this.mount_array(response.result.entradas);
                    }

                    if (response.result.saidas.length != 0){ 
                        this.saidas = this.mount_array(response.result.saidas);
                    }

                    if (response.result.denuncias.length != 0){ 
                        this.denuncias = this.mount_array(response.result.denuncias);
                    }
                }

                if (this.timestamps) {
                    this.refresh(this.teste);
                }else {
                    clearTimeout(this.looping);
                }
                }
            },

            mount_array(payload) {
                payload.forEach( i => i[1] = parseInt(i[1]));
                payload.forEach( i => i[0] = i[0]+"H");
                const header = [['Hora', 'Ligações']];
                return header.concat(payload);
            },

        },
        beforeRouteLeave(to, from, next) {
            this.teste = false;
            EventBus.$emit('reset-unit-filter');
            next();
	    },
    }
</script>

<style scoped>
</style>